import React, { useEffect, useState } from 'react';
import TintucPageApi from './TintucPageApi';
import CategoryApi from './CategoryApi';

const AdminCategoryEditPage = ({ currentCategoryId, currentCategoryType, currentCategoryName, clickChangeMenu }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [saveMessage, setSaveMessage] = useState('');
    const [categories, setCategories] = useState([]);  // For parent category selector

    const [formData, setFormData] = useState({
        id: null,
        name: '',
        type: currentCategoryType,
        order: 1,
        active: true,
        ownerId: null,
    });

    const isEdit = currentCategoryId != null;

    useEffect(() => {
        // Fetch existing categories for parent selection
        if (currentCategoryType) {
            TintucPageApi.getAllType(currentCategoryType)
                .then(data => setCategories(Array.isArray(data) ? data : []))
                .catch(console.error);
        }

        // Load existing data when editing
        if (isEdit) {
            setIsLoading(true);
            TintucPageApi.getAllType(currentCategoryType)
                .then(data => {
                    const found = Array.isArray(data) ? data.find(c => String(c.Id) === String(currentCategoryId)) : null;
                    if (found) {
                        setFormData({
                            id: found.Id,
                            name: found.Name || '',
                            type: found.Type || currentCategoryType,
                            order: found.Order || 1,
                            active: found.Active === true || found.Active === 'true',
                            ownerId: found.Owner_Id || null,
                        });
                    }
                })
                .catch(console.error)
                .finally(() => setIsLoading(false));
        }
    }, [currentCategoryId, currentCategoryType]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async () => {
        if (!formData.name.trim()) {
            setSaveMessage('Vui lòng nhập tên chuyên mục!');
            return;
        }
        setIsLoading(true);
        setSaveMessage('');
        try {
            const payload = {
                id: formData.id,
                name: formData.name,
                type: currentCategoryType,
                order: parseInt(formData.order) || 1,
                active: formData.active,
                ownerId: (formData.ownerId && formData.ownerId !== "" && formData.ownerId !== "null") ? parseInt(formData.ownerId) : null,
            };
            if (isEdit) {
                await CategoryApi.updateCategory(payload);
            } else {
                await CategoryApi.createCategory(payload);
            }
            setSaveMessage('Lưu thành công!');
            setTimeout(() => setSaveMessage(''), 3000);
        } catch (err) {
            setSaveMessage('Lưu thất bại!');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveAndBack = async () => {
        await handleSubmit();
        setTimeout(() => clickChangeMenu('categoryList'), 800);
    };

    return (
        <div>
            {/* ACTION BUTTONS - STICKY TOP */}
            <div className="social-box" style={{ position: 'sticky', top: '40px', zIndex: 1000, boxShadow: '0px 2px 4px rgba(0,0,0,0.1)' }}>
                <div className="header">
                    <div className="btn-group">
                        <button type="button" className="btn btn-success" onClick={handleSubmit} disabled={isLoading}>
                            <i className="icon-ok" /> {isLoading ? 'Đang lưu...' : 'Lưu'}
                        </button>
                        <button type="button" className="btn btn-success" onClick={handleSaveAndBack} disabled={isLoading}>
                            Lưu và Quay lại
                        </button>
                        <button
                            type="button"
                            className="btn"
                            onClick={() => clickChangeMenu('categoryList')}>
                            Quay lại
                        </button>
                    </div>
                    {saveMessage && (
                        <span style={{ marginLeft: '20px', color: saveMessage.includes('công') ? 'green' : 'red', fontWeight: 'bold' }}>
                            {saveMessage}
                        </span>
                    )}
                </div>
            </div>

            {/* FORM */}
            <div className="social-box">
                <div className="tab-content form-horizontal" style={{ padding: '20px' }}>
                    <h4 style={{ marginBottom: '20px', color: '#333' }}>
                        {isEdit ? 'Chỉnh sửa Chuyên mục' : 'Tạo Chuyên mục mới'} — {currentCategoryName}
                    </h4>

                    {/* Tên chuyên mục */}
                    <div className="control-group">
                        <label className="control-label">Tên chuyên mục: <span style={{ color: 'red' }}>*</span></label>
                        <div className="controls">
                            <input
                                type="text"
                                name="name"
                                className="span12"
                                value={formData.name}
                                onChange={handleInputChange}
                                placeholder="Nhập tên chuyên mục"
                            />
                        </div>
                    </div>

                    {/* Chuyên mục cha */}
                    {currentCategoryType === 17 && (
                        <div className="control-group">
                            <label className="control-label">Chuyên mục cha:</label>
                            <div className="controls">
                                <select
                                    name="ownerId"
                                    className="span12"
                                    value={formData.ownerId || ''}
                                    onChange={handleInputChange}
                                    style={{ maxWidth: '400px' }}
                                >
                                    <option value="">-- Cấp cao nhất --</option>
                                    {categories
                                        .filter(cat => String(cat.Id) !== String(currentCategoryId))
                                        .map(cat => (
                                            <option key={cat.Id} value={cat.Id}>
                                                {cat.Name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Thứ tự */}
                    <div className="control-group">
                        <label className="control-label">Thứ tự:</label>
                        <div className="controls">
                            <input
                                type="number"
                                name="order"
                                className="span12"
                                value={formData.order}
                                onChange={handleInputChange}
                                min="1"
                                style={{ maxWidth: '200px' }}
                            />
                        </div>
                    </div>

                    {/* Trạng thái kích hoạt */}
                    <div className="control-group">
                        <label className="control-label">Kích hoạt:</label>
                        <div className="controls" style={{ paddingTop: '5px' }}>
                            <label className="checkbox inline">
                                <input
                                    type="checkbox"
                                    name="active"
                                    checked={formData.active}
                                    onChange={handleInputChange}
                                />
                                <span style={{ marginLeft: '8px' }}>Hiển thị chuyên mục này</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminCategoryEditPage;
